import React, { useState, useRef } from 'react';
import { FiCopy } from 'react-icons/fi'; // Importing an icon for the copy button
export default CompanyKeyForm;

function CompanyKeyForm() {
  const [companyName, setCompanyName] = useState('');
  const [salt, setSalt] = useState('');
  const [generatedKey, setGeneratedKey] = useState('');

  // Use refs to retain focus on inputs
  const companyNameInputRef = useRef(null);
  const saltInputRef = useRef(null);

  const handleGenerateAndUploadKey = async () => {
    if (!companyName || !salt) {
      alert('Company Name and Salt cannot be empty');
      return;
    }

    const toast = (message) => {
      const toastEl = document.createElement('div');
      toastEl.classList.add('toast');
      toastEl.textContent = message;
    
      document.body.appendChild(toastEl);
    
      setTimeout(() => {
        toastEl.classList.add('fade-out');
        toastEl.addEventListener('transitionend', () => {
          toastEl.remove();
        });
      }, 3000);
    };

    const invalidRegex = /[^a-z0-9!@#$%^&*()_+={}\[\]:;"'<>,.?\/\\|-]/i;
    if (invalidRegex.test(companyName) || invalidRegex.test(salt)) {
      toast('Company Name and Salt must contain only alphanumeric characters and special characters, without any whitespace.');
      return;
    }

    try {
      const response = await fetch('/api/generate-key', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ companyName, salt }),
      });

      const data = await response.json();

      if (data.success) {
        setGeneratedKey(data.key);
        navigator.clipboard.writeText(data.key);
        alert(`Key generated: ${data.key} and copied to clipboard!`);
        // Refocusing the companyName input after generating key
        companyNameInputRef.current.focus();
      } else {
        alert('Failed to generate key');
      }
    } catch (error) {
      alert('Error generating key');
    }
  };

  const handleCopyToClipboard = () => {
    if (generatedKey) {
      navigator.clipboard.writeText(generatedKey);
      alert('Key copied to clipboard!');
    }
  };

  return (
    <div className="header" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <h2 style={{ marginBottom: '10px' }}>Generate Key</h2>
      <input
        type="text"
        placeholder="Company Name"
        className="styled-input"
        value={companyName}
        onChange={(e) => setCompanyName(e.target.value)}
        ref={companyNameInputRef} // Ref for the company name input
      />
      <input
        type="text"
        placeholder="Salt"
        className="styled-input"
        value={salt}
        onChange={(e) => setSalt(e.target.value)}
        ref={saltInputRef} // Ref for the salt input
        style={{ marginBottom: '30px' }}
      />
      <button
        className="fill-button w-button"
        onClick={handleGenerateAndUploadKey}
        style={{ marginBottom: '30px' }}
      >
        Generate Key
      </button>

      {generatedKey && (
        <div className="key-display">
          <h3>Key:</h3>
          <p className="generated-key-text">{generatedKey}</p>
          <button onClick={handleCopyToClipboard}>
            <FiCopy size={20} color="#404040" />
          </button>
        </div>
      )}
    </div>
  );
}
